<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import { Button } from '@/Components/ui'
</script>

<template>
    <Head :title="$t('Workshop')" />
    <PublicLayout>
        <section class="px-6 py-10 lg:px-12">
            <div class="mx-auto max-w-4xl">
                <h1 class="text-3xl font-bold">{{ $t('Workshop') }}</h1>
                <p class="mt-2 text-gray-600 dark:text-gray-400">
                    {{ $t('Inspektionen, Reparaturen, Montagen — fair kalkuliert, schnell erledigt. Bring dein Bike vorbei oder lass es bei dir abholen.') }}
                </p>

                <div class="mt-6 flex gap-3">
                    <Link href="/werkstatt/buchen">
                        <Button>{{ $t('Termin anfragen') }}</Button>
                    </Link>
                </div>

                <div class="mt-10 grid gap-6 sm:grid-cols-3">
                    <div class="rounded-xl border border-gray-200 bg-gray-50 p-5 dark:border-gray-800 dark:bg-gray-900/60">
                        <div class="mb-2 text-2xl">🔧</div>
                        <h3 class="font-semibold">Alle Marken & Modelle</h3>
                        <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">Ob Stadtrad, E-Bike, MTB oder Rennrad — wir reparieren was zwei Räder hat, unabhängig von Marke und Baujahr.</p>
                    </div>
                    <div class="rounded-xl border border-gray-200 bg-gray-50 p-5 dark:border-gray-800 dark:bg-gray-900/60">
                        <div class="mb-2 text-2xl">⚡</div>
                        <h3 class="font-semibold">Kurze Wartezeiten</h3>
                        <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">Die meisten Reparaturen erledigen wir noch am selben oder nächsten Tag. Einfach vorbeibringen oder abholen lassen.</p>
                    </div>
                    <div class="rounded-xl border border-gray-200 bg-gray-50 p-5 dark:border-gray-800 dark:bg-gray-900/60">
                        <div class="mb-2 text-2xl">💬</div>
                        <h3 class="font-semibold">Ehrliche Beratung</h3>
                        <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">Wir sagen dir, was dein Rad wirklich braucht — und was nicht. Faire Preise, keine versteckten Kosten.</p>
                    </div>
                </div>

                <div class="mt-12 rounded-2xl bg-gray-50 p-8 text-center dark:bg-gray-900">
                    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">{{ $t('Termin gefunden? Dann buchen wir das ein.') }}</h3>
                    <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">{{ $t('Im nächsten Schritt wählst du Leistungen aus und legst einen Wunschtermin fest.') }}</p>
                    <Link href="/werkstatt/buchen" class="mt-5 inline-block">
                        <Button size="lg">{{ $t('Termin anfragen') }}</Button>
                    </Link>
                </div>
            </div>
        </section>
    </PublicLayout>
</template>
